var map = {
	"./arrow-down-blue.svg": 1228,
	"./arrow-down-grey.svg": 1229,
	"./arrow-left.png": 1230,
	"./arrow-right-white.png": 1231,
	"./arrow-right.svg": 1232,
	"./badges/badge.png": 1233,
	"./banner-team.png": 379,
	"./banners/boxyButton.png": 378,
	"./banners/boxyCat.png": 1234,
	"./banners/boxycat_banner.png": 1235,
	"./banners/boxycats.gif": 377,
	"./big_unicorn.png": 1236,
	"./blue-loader.svg": 238,
	"./circle-grey.svg": 1237,
	"./circle.svg": 1238,
	"./coinbaseWalletIcon.svg": 241,
	"./diamond.png": 1239,
	"./dropdown-blue.svg": 1240,
	"./dropdown.svg": 1241,
	"./dropup-blue.svg": 1242,
	"./engineers/banderas.jpg": 1243,
	"./engineers/christopher.jpg": 1244,
	"./engineers/dhimas.jpg": 1245,
	"./engineers/fajar.jpg": 1246,
	"./engineers/matt.png": 1247,
	"./ethereum-logo.png": 240,
	"./fortmaticIcon.png": 242,
	"./gear.svg": 1248,
	"./happyyudi.jpg": 1249,
	"./hero.png": 1250,
	"./icons/instagram.png": 1251,
	"./icons/tiktok.png": 1252,
	"./icons/twitter.png": 1253,
	"./icons/youtube.png": 1254,
	"./link.svg": 1255,
	"./magnifying-glass.svg": 1256,
	"./menu.svg": 1257,
	"./metamask.png": 239,
	"./personImgVec.png": 1258,
	"./personImgVec4x.png": 1259,
	"./plus-blue.svg": 1260,
	"./plus-grey.svg": 1261,
	"./portisIcon.png": 243,
	"./question-mark.svg": 1262,
	"./question.svg": 1263,
	"./spikes.png": 1264,
	"./spinner.svg": 1265,
	"./streamers/icey.jpg": 1266,
	"./streamers/jam.jpg": 1267,
	"./streamers/miguela.jpg": 1268,
	"./streamers/riri.jpg": 1269,
	"./streamers/rizzi.jpg": 1270,
	"./streamers/roche.jpg": 1271,
	"./streamers/seyrah.jpg": 1272,
	"./test.png": 1273,
	"./token-list-logo.png": 1274,
	"./token-list/lists-dark.png": 1275,
	"./token-list/lists-light.png": 1276,
	"./token-logo.png": 376,
	"./tokenlistsgrouped.png": 1277,
	"./trustWallet.png": 1278,
	"./unsplash.png": 1279,
	"./vector-profile-img/charles.png": 380,
	"./vector-profile-img/charles4x.png": 381,
	"./vector-profile-img/chris.png": 382,
	"./vector-profile-img/chris4x.png": 383,
	"./vector-profile-img/dara.png": 384,
	"./vector-profile-img/dara4x.png": 385,
	"./vector-profile-img/dhimas.png": 386,
	"./vector-profile-img/dhimas4x.png": 387,
	"./vector-profile-img/fajar.png": 388,
	"./vector-profile-img/fajar4x.png": 389,
	"./vector-profile-img/gii.png": 390,
	"./vector-profile-img/gii4x.png": 391,
	"./vector-profile-img/icey.png": 392,
	"./vector-profile-img/icey4x.png": 393,
	"./vector-profile-img/jamjam.png": 394,
	"./vector-profile-img/jamjam4x.png": 395,
	"./vector-profile-img/matt.png": 396,
	"./vector-profile-img/matt4x.png": 397,
	"./vector-profile-img/miguela.png": 398,
	"./vector-profile-img/miguela4x.png": 399,
	"./vector-profile-img/phew.png": 400,
	"./vector-profile-img/phew4x.png": 401,
	"./vector-profile-img/richard.png": 402,
	"./vector-profile-img/richard4x.png": 403,
	"./vector-profile-img/riri.png": 404,
	"./vector-profile-img/riri4x.png": 405,
	"./vector-profile-img/seyrah.png": 406,
	"./vector-profile-img/seyrah4x.png": 407,
	"./vector-profile-img/silhouette.png": 1280,
	"./vector-profile-img/silhouette4x.png": 1281,
	"./vector-profile-img/yudi.png": 408,
	"./vector-profile-img/yudi4x.png": 409,
	"./walletConnectIcon.svg": 244,
	"./wand.svg": 1282,
	"./wand1.svg": 1283,
	"./x.svg": 1284
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 370;